import { WorkspacePremium } from '@mui/icons-material';

export const Challenge = () => <WorkspacePremium fontSize="medium" />;
